// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2yODN","consentsList":"PatientConsents_consentsList__2Eg47","consentsListEmpty":"PatientConsents_consentsListEmpty__2oz4Q"};